module.exports = __webpack_public_path__ + "static/media/indices3.443b3e6b.jpg";